import {
    Box,
    FormControl,
    FormHelperText,
    IconButton,
    MenuItem,
    Select,
    Typography
} from "@mui/material";
import {
    DayOfWeek,
    WeeklyRecurrence
} from "../../models";
import {
    Dispatch,
    SetStateAction,
    useCallback
} from "react";

import React from "react";
import _ from "lodash";

type WeeklyRecurrenceFormProps = {
    weeklyRecurrence: WeeklyRecurrence;
    setWeeklyRecurrence: Dispatch<SetStateAction<WeeklyRecurrence>>;
    error: Record<keyof WeeklyRecurrence, string> | undefined;
};

export const WeeklyRecurrenceForm = ({ weeklyRecurrence, setWeeklyRecurrence, error }: WeeklyRecurrenceFormProps) => {

    const weeklyRecurrenceDayOfWeekToggle = useCallback((day: DayOfWeek) => {
        setWeeklyRecurrence(prev => {
            const newDaysOfWeek = prev.daysOfWeek ? [...prev.daysOfWeek] as Array<DayOfWeek> : new Array<DayOfWeek>();
            const index = newDaysOfWeek.indexOf(day);
            if (index === -1) {
                newDaysOfWeek.push(day);
            } else {
                newDaysOfWeek.splice(index, 1);
            }
            // Sort the days of the week, i.e. Sunday, Monday, Tuesday, etc.
            newDaysOfWeek.sort((a, b) =>
                Object.values(DayOfWeek).indexOf(a) - Object.values(DayOfWeek).indexOf(b)
            );
            return { ...prev, daysOfWeek: newDaysOfWeek };
        });
    }, []);

    return (
        <>
            <Typography>Every</Typography>
            <Box display="flex" gap={1} alignItems="center">
                <FormControl error={!!error?.interval}>
                    <Select
                        id="weeklyInterval"
                        name="weeklyInterval"
                        value={weeklyRecurrence.interval ?? 1}
                        onChange={(e) => setWeeklyRecurrence(prev => ({ ...prev, interval: parseInt(e.target.value as string) }))}
                        variant="standard"
                        MenuProps={{
                            sx: {
                                maxHeight: 250
                            }
                        }}
                    >
                        {Array(13).fill(0).map((_, i) => (
                            <MenuItem key={i + 1} value={i + 1}>{i + 1}</MenuItem>
                        ))}
                    </Select>
                    <FormHelperText>{error?.interval}</FormHelperText>
                </FormControl>
                <Typography>week(s)</Typography>
            </Box>
            <Typography>On</Typography>
            <Box display="flex" flexDirection="column">
                <Box display="flex" gap={0.25}>
                    {Object.values(DayOfWeek).map((day) => {
                        const isSelected = ((weeklyRecurrence.daysOfWeek ?? []) as Array<DayOfWeek>).indexOf(day) !== -1;
                        return (
                            <IconButton
                                key={day}
                                onClick={() => weeklyRecurrenceDayOfWeekToggle(day)}
                                color={isSelected ? "primary" : "default"}
                                sx={{
                                    border: isSelected ? theme => `2px solid ${theme.palette.primary.main}` : "1px solid transparent",
                                    borderRadius: "5px",
                                    height: 40,
                                    width: 40
                                }}
                            >
                                {_.capitalize(day.substring(0, 1))}
                            </IconButton>
                        );
                    })}
                </Box>
                {error?.daysOfWeek && (
                    <FormHelperText error>{error.daysOfWeek}</FormHelperText>
                )}
            </Box>
        </>
    );
};